const IS_DEV = process.env.NODE_ENV === 'development';

// i18n common config
export default {
    debug: IS_DEV,
    defaultNS: 'app',
    fallbackNS: 'common',
    ns: ['app', 'common'],
};
